import { css } from '@emotion/react';
import { Icon, Tooltip, tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

import { getBrowserIcon } from '@hotjar/webapp/utils/icons';

interface BrowserIconProps {
  browser: string;
}

export function BrowserIcon({ browser }: BrowserIconProps): JSX.Element {
  const { t } = useTranslation('feedback', { keyPrefix: 'feedback-card.browser' });
  return (
    <Tooltip text={browser}>
      <Icon
        description={t('browser-icon-description')}
        icon={getBrowserIcon(browser)}
        css={css`
          margin-right: ${tokens.spacer.x1};
        `}
      />
    </Tooltip>
  );
}
